import AddressAutoComplete from 'components/elements/AddressAutoComplete';
import WithLabel from 'components/elements/WithLabel';
import { useAddressCoords, useAddressFilter } from 'state/filterDocuments';

const searchInputStyle = {
  boxShadow: '0px 8px 16px 0px #0000001F',
  height: '48px',
};

const AddressFilter = () => {
  const { addressFilter, setAddressFilter } = useAddressFilter();
  const { setAddressCoords } = useAddressCoords();

  return (
    <WithLabel label="Address">
      <AddressAutoComplete
        placeholder="Search by address"
        externalValue={addressFilter}
        onSelect={(address, coords) => {
          setAddressFilter(address);
          setAddressCoords([coords.lng, coords.lat]);
        }}
        onClear={() => {
          setAddressFilter('');
          setAddressCoords(null);
        }}
        sx={searchInputStyle}
      />
    </WithLabel>
  );
};

export default AddressFilter;
